import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { byAppVariant } from '@/consts/AppVariants';
import noGamesFoundChristmas from '@/public/assets/image/global-states/empty/christmas/empty-christmas-state.webp';
import noGamesFoundBase from '@/public/assets/image/global-states/empty/default/empty-default-state-mobile@2x.webp';
import { cn } from '@/utils/cn';

interface Props {
  imageClassName?: string;
  className?: string;
}

export default function EmptyGamesState({ imageClassName, className }: Props) {
  const t = useTranslations('lobby.filters');
  const noGamesFound = byAppVariant({
    christmas: noGamesFoundChristmas,
    default: noGamesFoundBase,
  });

  return (
    <>
      <div className={cn('relative isolate flex flex-col items-center mb-6.5 lg:mb-5 lg:gap-0.5 lg:mt-4.75 gap-2', className)}>
        <div className="absolute -top-1.5 sm:top-[9%] lg:-top-1.5 w-[7.688rem] lg:max-w-none mt-7.5 -z-1 h-[7.688rem] rounded-full blur-2xl opacity-80 pointer-events-none bg-main-back-gradient" />
        <Image
          src={noGamesFound}
          alt="no-games-found"
          width={600}
          height={480}
          className={cn('w-50.5 h-42.5', imageClassName)}
        />
        <p className="text-white font-regular text-[1rem] max-lg:-mt-2.25 leading-6 text-center lg:font-regular lg:text-lg tracking-[-0.001em] lg:leading-7">
          {t.rich('we-couldnt-find-the-game-youre-looking-for', {
            br: () => <span className="lg:hidden"><br /></span>,
          })}
        </p>
      </div>
    </>
  );
}
